export default [
    {
        path: '/jobs',
        name: 'JobsIndex',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Jobs',
        },
        components: {
            default: () => import('@views/jobs/JobsIndexAgent.vue'),
        },
    },
    {
        path: '/jobs/create',
        name: 'JobCreate',
        meta: {
            requiresAuth: true,
            allowRoles: null,
            denyRoles: null,
            title: 'Create job',
        },
        components: {
            default: () => import('@views/jobs/JobCreate.vue'),
        },
    },
];
